{
  "version": 1,
  "asset_id": "fcdac721-484d-45e6-a055-8bee01593cde",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/fcdac721-484d-45e6-a055-8bee01593cde/beverly-hills-shingle-replacement-in-progress-480w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/fcdac721-484d-45e6-a055-8bee01593cde/beverly-hills-shingle-replacement-in-progress-480w.webp",
  "original_filename": "beverly-hills-shingle-replacement-in-progress-480w.webp",
  "size": 22700,
  "content_type": "image/webp",
  "created_at": "2026-07-29T14:07:05Z"
}
